import hljs from 'highlight.js'
import 'highlight.js/styles/nord.css'

export class Highlight {
	constructor() {
		this.highlight();
		this.copyAll();
	}

	private highlight = () => {
		setTimeout(() => {
			hljs.highlightCode = () => {
				let blocks = document.querySelectorAll('pre code');
				[].forEach.call(blocks, hljs.highlightBlock);
			};
			hljs.highlightCode();
		}, 100)
	}
	private copyAll = () => {
		setTimeout(() => {
			const dataCopyList: NodeList = document.querySelectorAll("[data-copy-all]");
			Array.prototype.slice.apply(dataCopyList).forEach((element: HTMLElement) => {
				element.addEventListener("click", (e: Event) => {
					let target = e.currentTarget as HTMLElement;
					if (window.getSelection) {
						let selection = window.getSelection();
						let range = document.createRange();
						range.selectNodeContents(target);
						selection.removeAllRanges();
						selection.addRange(range);
						document.execCommand("Copy");
					}
				});
			});
		}, 1)
	}
}
